import { ApiEndPoints, NetworkManager } from "../network";

export class FollowUpPlaceService {
  static getAllFollowUpPlaces = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.followupPlaces
    });
  };

  static addFollowUpPlace = (followUpPlace) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.followupPlaces,
      data: { ...followUpPlace },
    });
  };

  static updateFollowUpPlace = (id, followUpPlace) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.followupPlaces,
      data: { ...id, ...followUpPlace },
    });
  };

  static deleteFollowUpPlace = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.followupPlaces + "/" + id,
      data: { ...id },
    });
  };
}
